module.exports = __webpack_public_path__ + "img/cryingicon.81d31e62.svg";